<template>
  <section
    class="section container pt-5"
    style="position: relative; min-height: 100vh"
  >
    <!-- Mensaje para escritorio -->
    <div
      class="message is-info"
      v-if="!is_mobile"
      style="max-width: 420px; margin: 2rem auto"
    >
      <div
        class="message-header"
        style="justify-content: center; background: #e3f6fc"
      >
        <span class="icon has-text-info" style="margin-right: 0.5em">
          <i class="fa fa-mobile-alt"></i>
        </span>
        <span style="font-weight: 600">
          {{ $t("mobile verification required") }}
        </span>
      </div>
      <div class="message-body has-text-centered" style="padding: 2rem 1.5rem">
        <div class="title is-5" style="color: #0984e3">
          <span class="icon is-medium" style="vertical-align: middle">
            <i class="fa fa-info-circle"></i>
          </span>
          <span style="vertical-align: middle">
            {{
              $t("you must complete the identity validation on a mobile device")
            }}
          </span>
        </div>
        <div class="subtitle is-6 mt-3">
          {{ $t("scan this qr code with your phone to continue:") }}
        </div>
        <figure class="image is-inline-block" style="margin-bottom: 0.5rem">
          <img
            :src="`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${current_location}`"
            alt="QR Code for Identity Verification"
            style="
              border-radius: 12px;
              border: 2px solid #b2bec3;
              box-shadow: 0 2px 12px rgba(44, 62, 80, 0.08);
            "
          />
        </figure>
        <div class="help is-info" style="margin-top: 1rem">
          <span class="icon"><i class="fa fa-arrow-down"></i></span>
          {{ $t("open your phone's camera and point it at the qr code.") }}
        </div>
      </div>
    </div>

    <!-- Flujo móvil -->
    <div v-else>
      <div class="box pt-3" style="max-width: 480px; margin: 0 auto">
        <div class="title is-4 has-text-centered mb-2" style="color: #00b894">
          {{ $t("identity verification") }}
        </div>
        <transition name="fade" mode="out-in">
          <div v-show="current_step == 'face'" key="face">
            <div
              class="title is-5 has-text-centered mb-2"
              v-if="retrived_verification_data"
            >
              {{ $t("welcome") }} {{ retrived_verification_data.first_name }}
              {{ retrived_verification_data.last_name }}
            </div>
            <!-- <div class="subtitle is-6 has-text-centered mb-3">
              {{ $t("well now guide you through the verification process") }}
            </div> -->
          </div>
        </transition>
        <div>
          <transition name="fade" mode="out-in">
            <face
              ref="face"
              @error="show_error"
              @success="success_face"
              v-show="current_step == 'face'"
              key="face-step"
            />
          </transition>
          <transition name="fade" mode="out-in">
            <id-front
              ref="id_front"
              @error="show_error"
              @success="success_id_front"
              v-show="current_step == 'id_front'"
              key="id-front-step"
            />
          </transition>
          <transition name="fade" mode="out-in">
            <id-back
              ref="id_back"
              @error="show_error"
              @success="success_id_back"
              v-show="current_step == 'id_back'"
              key="id-back-step"
            />
          </transition>
          <transition name="fade" mode="out-in">
            <div
              v-if="current_step == 'finish'"
              class="notification is-success mt-5"
              key="finish-step"
              style="text-align: center"
            >
              <div class="message-header" style="justify-content: center">
                <div class="title is-5">
                  <span class="icon"><i class="fa fa-check-circle"></i></span>
                  {{ $t("verification completed") }}
                </div>
              </div>
              <div class="message-body">
                <p>
                  <span class="icon"><i class="fa fa-smile"></i></span>
                  {{
                    $t(
                      "thank you for your verification, you will be redirected shortly"
                    )
                  }}
                </p>
              </div>
            </div>
          </transition>
        </div>
        <transition name="fade">
          <div class="message is-danger mt-5" v-if="error">
            <!-- <div class="message-header">
              <p>
                <span class="icon"
                  ><i class="fa fa-exclamation-triangle"></i
                ></span>
                {{ $t("oops, an exception has ocurred!") }}
              </p>
            </div> -->
            <div class="message-body">
              <p v-html="error"></p>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
import { warning_message, get, generate_error_message_text } from "@/utils";
import Face from "./Face.vue";
import IdFront from "./IdFront.vue";
import IdBack from "./IdBack.vue";

export default {
  name: "IdentityVerificationPerform",
  components: { Face, IdFront, IdBack },
  data() {
    return {
      retrived_verification_data: null,
      error: "",
      current_step: "face", // face, id_front, id_back, finish
    };
  },
  computed: {
    is_mobile() {
      // Detecta dispositivos móviles usando el user agent
      // Puedes usar una librería como "mobile-detect" para una detección más robusta
      // return /Mobi|Android/i.test(navigator.userAgent);
      // Alternativamente, puedes usar una expresión regular más completa
      // return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      //   navigator.userAgent
      // );

      /** Return true when localhost */
      if (window.location.hostname === "localhost") return true;

      return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        navigator.userAgent
      );
    },
    current_location() {
      // Devuelve la URL actual para generar el código QR
      return window.location.href;
    },
  },
  methods: {
    show_error(error) {
      this.error = generate_error_message_text(error);
    },
    success_face() {
      let v = this;
      v.current_step = "id_front";
      v.error = ""; // Limpiar errores previos
      v.$refs.id_front.start();
    },
    success_id_front() {
      let v = this;
      v.current_step = "id_back";
      v.error = ""; // Limpiar errores previos
      v.$refs.id_back.start();
    },
    success_id_back() {
      let v = this;
      v.current_step = "finish";
      v.error = ""; // Limpiar errores previos
    },
    init_camera() {
      // Inicia la cámara dependiendo del paso
      let v = this;
      if (v.current_step === "face") {
        v.$refs.face.start();
      } else if (v.current_step === "id_front") {
        v.$refs.id_front.start();
      } else if (v.current_step === "id_back") {
        v.$refs.id_back.start();
      }
    },
    retrieve_verification() {
      let v = this;
      let uuid = v.$route.params.uuid;
      if (!uuid) {
        warning_message(v.$t("missing verification uuid"));
      } else {
        // v.$root.loader(true);
        get("/identity/perform", { uuid: uuid })
          .then((r) => {
            v.retrived_verification_data = r;
          })
          .catch((error) => {
            console.error(error);
            v.error = generate_error_message_text(error);
          })
          .finally(() => {
            v.$root.loader(false);
          });
      }
    },
  },
  mounted() {
    let v = this;
    navigator.mediaDevices
      .enumerateDevices()
      .then((devices) => {
        const videoDevices = devices.filter(
          (device) => device.kind === "videoinput"
        );
        // Puedes mejorar aquí si quieres filtrar cámaras front/back
        console.log("Cámaras disponibles:", videoDevices);

        v.retrieve_verification();
        v.init_camera();
      })
      .catch((error) => {
        console.error("Error accessing media devices:", error);
      });
  },
  created() {},
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.box {
  box-shadow: 0 2px 12px rgba(44, 62, 80, 0.08);
  border-radius: 12px;
  /* background: #fff; */
  padding: 2.5rem 1.5rem 2rem 1.5rem;
}
</style>
